import { render } from "./InvoicePage.vue?vue&type=template&id=f8d1cf0c"
import script from "./InvoicePage.vue?vue&type=script&lang=js"
export * from "./InvoicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__